export enum UpdateValueField {
    ASSIGNEE = 'assignee',
    TEAM = 'team'
}
